/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * GetApplicationSessionConnectionRedirectHandler.js--
 *
 *      inherited Class to handle <get-application-session-connection-redirect>
 */

import RedirectHandler from "./redirectHandler";

export default function GetApplicationSessionConnectionRedirectHandler() {
   this.requestTag = "get-application-session-connection-redirect"; // the XML request tag name
   this.responseTag = "application-session-connection-redirect"; // the XML response tag name
}

// inherits RedirectHandler prototype
GetApplicationSessionConnectionRedirectHandler.prototype = new RedirectHandler();

// constructor
GetApplicationSessionConnectionRedirectHandler.constructor = GetApplicationSessionConnectionRedirectHandler;
